
export const state = {
    currentUser: sessionStorage.getItem('authUser'),
}

export const mutations = {
    update_profile(state, newValue) {
        state.currentUser = newValue
        localStorage.setItem('user', JSON.stringify(newValue))
    },
    update_profile_state (state, newValue) {
        state.currentUser.data = newValue
    }
}


export const actions = {
    updateProfile({ commit }, { userData } = {}) {
        let data = JSON.parse(localStorage.getItem('user'));
        data.data = userData;
        commit('SET_CURRENT_USER', data);
    },
    update_profile_state({ commit }, { userData } = {}) {
        commit('SET_CURRENT_USER', userData);
    }
}
